export default __webpack_public_path__ + "234535eb305835e31eac7ee41b2c9c91.jpg";